import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import { getIsGwp10027NonprofitPricingPage } from "@/templates/non-profit-pricing-page/src/feature-gates.ts";

const fineprintContainerCss = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    textAlign: "center"
});

const headerCss = css({
    fontSize: "32px",
    fontWeight: 800,
    margin: "0 0 14px 0",
    [media.above.sm]: {
        fontSize: "48px",
        margin: "0 0 16px 0"
    }
});

const bodyCss = css({
    fontSize: "16px",
    margin: "0",
    maxWidth: "768px"
});

export const Fineprint = () => {
    const isGwp10027 = getIsGwp10027NonprofitPricingPage();

    return (
        <div css={fineprintContainerCss}>
            <h2 css={headerCss}>
                <FormattedMessage
                    id="NonprofitPage.fineprint.header"
                    defaultMessage="The fine print"
                />
            </h2>
            <p css={bodyCss}>
                {isGwp10027 && (
                    <FormattedMessage
                        id="NonprofitPage.fineprint.body.gwp10027"
                        defaultMessage="Atlassian aims to unleash the potential of every team, including nonprofits and social enterprises, but not every organization may meet Atlassian’s Social Impact License eligibility criteria."
                    />
                )}

                {!isGwp10027 && (
                    <FormattedMessage
                        id="NonprofitPage.fineprint.body"
                        defaultMessage="Atlassian aims to unleash the potential of every team, including nonprofits and social enterprises, but not every organization may meet Atlassian’s Community License eligibility criteria."
                    />
                )}
            </p>
            <br />
            <p css={bodyCss}>
                {isGwp10027 && (
                    <FormattedMessage
                        id="NonprofitPage.fineprint.body.additional"
                        defaultMessage="Atlassian verifies Social Impact License eligibility in partnership with Goodstack, yet determines qualification for discounted licenses at its sole discretion. We reserve the right to grant or deny an individual or organization’s application for a discounted license, or to discontinue an active discounted license, at any time, for any reason, and to supplement or amend our Social Impact License eligibility guidelines at any time."
                    />
                )}

                {!isGwp10027 && (
                    <FormattedMessage
                        id="NonprofitPage.fineprint.body.additional"
                        defaultMessage="Atlassian verifies Community License eligibility in partnership with Goodstack, yet determines qualification for discounted licenses at its sole discretion. We reserve the right to grant or deny an individual or organization’s application for a discounted license, or to discontinue an active discounted license, at any time, for any reason, and to supplement or amend our Community License eligibility guidelines at any time."
                    />
                )}
            </p>
        </div>
    );
};
Fineprint.displayName = "FineprintSection";
